import type { IntlKey, KeySuffix } from 'locales';
import type { Underlying } from 'models/underlying';

export const DEFAULT_ERROR_SEVERITY: FormErrorSeverity = 'Warning';
export type FormErrorSeverity = 'Warning' | 'Error' | 'Failure';

export type UnderlyingFormError = Readonly<{
  underlying: Underlying;
  translationKey: string;
}>;

export type FormRecord = Record<string, unknown>;
export type FormError<Form = FormRecord, Keys extends string = string, KeyPrefix extends string = string> = Readonly<{
  fields?: readonly (keyof Form)[];
  severity?: FormErrorSeverity;
  translationKey?: IntlKey | KeySuffix<Keys, KeyPrefix>;
  message?: string;
  underlyingValidationErrors?: readonly UnderlyingFormError[];
  isDisplayedInUnderlyings?: boolean;
  isDisplayedInSummary?: boolean;
  /** @deprecated use isDisplayedInSummary instead */
  isDisplayedInResume?: boolean;
  isIgnoredForExecOnly?: boolean;
  values?: { [id: string]: unknown };
  isMandatory?: boolean;
  isHidden?: boolean;
}>;

export type FormResult<T = any> = Readonly<{
  blockIndicative: boolean;
  blockTradeable: boolean;
  errors: FormError<T>[];
}>;

export interface TranslatedValidationError {
  message: string;
  severity: FormErrorSeverity;
  isDisplayedInSummary?: boolean;
  isDisplayedInUnderlyings?: boolean;
}
